import { YardSpotLatestHistory } from '../../api/yardCheck';

// We don't have real occupancy data (trailer_lineage) wired up yet — this is
// a proxy from the last RTLS read: a trailer number if one was read, else
// "Available" for a spot with history but no trailer number, or "No RTLS
// read yet" for a spot with no history at all.
export function formatYardSpotCardDetailLine(
  history: YardSpotLatestHistory | null
): string {
  if (!history) return 'No RTLS read yet';
  return history.trailerNumberOcrReading || history.trailerNumberExpected || 'Available';
}

type RtlsImages = Partial<
  Pick<YardSpotLatestHistory, 'annotatedCropUrl' | 'croppedImgUrl' | 'processedImgUrl'>
> & { annotatedImgUrl?: string | null };

// The image shown inline for an RTLS read: the annotated crop, else the plain
// crop, else the processed frame.
export const rtlsPreviewImage = (read: RtlsImages | null | undefined): string | null =>
  read?.annotatedCropUrl || read?.croppedImgUrl || read?.processedImgUrl || null;

// The image shown fullscreen: the uncropped annotated frame, else the preview.
export const rtlsFullscreenImage = (read: RtlsImages | null | undefined): string | null =>
  read?.annotatedImgUrl || rtlsPreviewImage(read);

export const formatTimestamp = (value: string | null): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

export const formatConfidence = (value: number | null): string => {
  if (value === null || value === undefined) return '-';
  const pct = value <= 1 ? value * 100 : value;
  return `${pct.toFixed(1)}%`;
};

export const verdictColor = (
  verdict: string | null
): 'success' | 'error' | 'warning' | 'default' => {
  switch ((verdict || '').toUpperCase()) {
    case 'MATCH':
      return 'success';
    case 'MISMATCH':
      return 'error';
    case 'NO_READ':
      return 'warning';
    default:
      return 'default';
  }
};
